import * as React from "react";

interface IProps {
    id?: string;
    value: string;
    title: string;
    className?: string;
    children?: React.ReactNode[] | React.ReactNode;
}

class TabPane extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    public render() {
        return (
            <div className={`${this.props.className}`}>
                {this.props.children}
            </div >
        );
    }
}

export default TabPane;


// WEBPACK FOOTER //
// ./src/Components/Tabview/Tabpane/TabPane.tsx